// extracted by mini-css-extract-plugin
export default {"btn":"addButton_btn__kej1H","btn__plus":"addButton_btn__plus__HWU6m"};